module.exports = __webpack_public_path__ + "img/jne.52a79ee2.png";